import "./App.scss";
import TextType from "./components/TextType";
import { COLORS } from "./constants/colors";

export default function LandingPage() {
    return (
        <main className="main">
            <div className="centeredbox">
                <div className="innerbox">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "120px" }}>
                        <TextType
                            text={["Louisa & Carlo", "Together forever", "We say yes!"]}
                            as="h1"
                            typingSpeed={70}
                            pauseDuration={1400}
                            deletingSpeed={35}
                            loop={true}
                            showCursor={true}
                            cursorCharacter="_"
                            textColors={[COLORS.burgundy[700], COLORS.burgundy[800], COLORS.burgundy[900]]}
                            className="landing-title"
                            style={{ fontWeight: 700, fontSize: "4rem"}}
                        />
                    </div>
                </div>
            </div>
        </main>
    );
}
